import { imageApi } from '../api/imageApi'

const MAX_FILE_SIZE_BYTES = 8 * 1024 * 1024

/** Uploads the given files to the backend (StorageService) and returns their resulting URLs, usable directly as <img src>. */
export async function uploadFiles(files: FileList | null): Promise<string[]> {
  if (!files || files.length === 0) return []
  const oversized = Array.from(files).find((file) => file.size > MAX_FILE_SIZE_BYTES)
  if (oversized) {
    throw new Error(`Datei "${oversized.name}" ist zu groß (max. 8 MB pro Foto)`)
  }
  const uploaded = await Promise.all(Array.from(files).map((file) => imageApi.upload(file)))
  return uploaded.map((result) => result.url)
}
